import service from '@/services/cajas/movimiento'

const getDefaultState = () => ({
  movimiento: {
    tipo: 'MANUAL',
    montoIngreso: 0,
    montoEgreso: 0,
    medioPago: 'EFECTIVO',
    detalle: ''
  },
  tipos: {
    ingreso: ['MANUAL'],
    egreso: ['MANUAL', 'BANCOS', 'COMPRA']
  },
  mediosPago: ['EFECTIVO', 'TARJETA', 'TRANSFERENCIA', 'OTRO'],
  list: [],
  pageInfo: {},
  totalRegistros: 0,
  montosTotales: {
    ingresos: 0,
    egresos: 0,
    saldo: 0
  },
  cierreMedios: [],
  currentRow: null,
  saved: 'null'
})

export const state = () => getDefaultState()

export const mutations = {
  RESET_STATE: state => Object.assign(state, getDefaultState()),
  RESET: state => (state.movimiento = { ...getDefaultState().movimiento }),
  SET_ROW: (state, row) => (state.currentRow = row),
  SET_LIST: (state, obj) => {
    state.list = [...new Set([...state.list.map(JSON.stringify), ...obj.feed.map(JSON.stringify)])].map(JSON.parse)
    state.pageInfo = obj.pageInfo
  },
  UPDATE_LIST: (state, obj) => {
    const nObj = state.list.find(e => e._id === obj._id)
    if (!nObj) state.list = [obj, ...state.list]
    else Object.keys(nObj).forEach(i => (nObj[i] = obj[i]))
    state.saved = true
  }
  // SET_MOVIMIENTO: (state, obj) => {
  //   state.sesion = obj
  // }

  // DELETE_LIST: (state, { obj }) => {
  //   state.list = state.list.filter(e => e._id !== obj._id)
  // },
  // SAVE_CHANGES: (state, obj) => {
  //   state.sesion = obj
  //   state.saved = false
  // }
}

export const actions = {
  resetList: ({ state }) => {
    state.list = []
    state.pageInfo = {}
  },
  resetMovimiento: ({ commit }) => commit('RESET'),

  readTotal: async ({ state }, { sesion }) =>
    service.readTotal(sesion).then(response => {
      state.totalRegistros = response
    }),

  readMontosTotales: async ({ state }, { sesion }) =>
    service.readMontosTotales(sesion).then(response => {
      state.montosTotales = response

      return true
    }),

  readByMedioPago: async ({ state }, { sesion }) =>
    service.readByMedioPago(sesion).then(response => {
      state.cierreMedios = response

      return true
    }),

  readBySearchString: async ({ state }, { sesion, searchString }) => service.readBySearchString(sesion, searchString),

  readAllByEmisor: async ({ commit, state, dispatch }, { restart = false, sesion, limit = 10, filter = null }) => {
    if (restart) await dispatch('resetList')

    return service.readAllByEmisor(sesion, state.pageInfo.nextPageCursor, limit, filter).then(response => {
      return commit('SET_LIST', response)
    })
  },

  create: async ({ commit, rootGetters, state, dispatch }, mov) => {
    mov.montoIngreso = Number(mov.montoIngreso)
    mov.montoEgreso = Number(mov.montoEgreso)

    delete mov._id
    return service
      .create({
        ...mov,
        emisor: {
          _id: await rootGetters['facturacion/emisorStore/get_Id']
        }
      })
      .then(result => {
        commit('UPDATE_LIST', {
          ...mov,
          _id: result._id,
          createdAt: result.createdAt,
          saldo: result.saldo,
          userSession: {
            fullname: result.userSession.fullname
          }
        })

        state.movimiento._id = result._id

        return result
      })
  }

  // readById: async ({ commit }, { _id }) =>
  //   service.readById(_id).then(response => {
  //     commit('SET_MOVIMIENTO', response)
  //     return response
  //   })

  // delete: ({ commit }, { items }) =>
  //   service.delete(items).then(result => {
  //     result.forEach(i => {
  //       if (i.state) commit('DELETE_LIST', { obj: i })
  //     })
  //     return result
  //   }),
  // saveChanges: ({ commit }, input) => commit('SAVE_CHANGES', input)
}

// export const getters = {
//   sesionStatus: state => value => {
//     const status = state.status.find(e => e.value === value)

//     return status?.text || 'info'
//   }
// }
